import type {
  StatsData,
  StatsFilters,
  DispatcherStats,
  FleetTruck,
  OrderDocument,
} from "./types"

const mockDispatchers: DispatcherStats[] = [
  {
    id: "1",
    name: "Jan Nowak",
    driversCount: 8,
    ordersCount: 120,
    revenue: 93600,
    distance: 86400,
    distanceDiff: 4123,
    roadCosts: 12096,
    roadCostsDiff: 154,
    fuel: 24192,
    fuelDiff: 860,
    drivingTime: 2172,
    loadedPercent: 90,
    emptyPercent: 10,
  },
  {
    id: "2",
    name: "Tomek Pajak",
    driversCount: 9,
    ordersCount: 126,
    revenue: 105966,
    distance: 81900,
    distanceDiff: 102,
    roadCosts: 12121,
    roadCostsDiff: 987,
    fuel: 23751,
    fuelDiff: 1500,
    drivingTime: 2155,
    loadedPercent: 91,
    emptyPercent: 9,
  },
  {
    id: "3",
    name: "Maciej Nowicki",
    driversCount: 10,
    ordersCount: 130,
    revenue: 106600,
    distance: 92300,
    distanceDiff: 3907,
    roadCosts: 15506,
    roadCostsDiff: 250,
    fuel: 23998,
    fuelDiff: -900,
    drivingTime: 2483,
    loadedPercent: 95,
    emptyPercent: 5,
  },
  {
    id: "4",
    name: "Roman Marczak",
    driversCount: 9,
    ordersCount: 135,
    revenue: 107865,
    distance: 99900,
    distanceDiff: 2353,
    roadCosts: 17083,
    roadCostsDiff: 1100,
    fuel: 26973,
    fuelDiff: 80,
    drivingTime: 2039,
    loadedPercent: 88,
    emptyPercent: 12,
  },
  {
    id: "5",
    name: "Anna Wozna",
    driversCount: 8,
    ordersCount: 128,
    revenue: 99968,
    distance: 83328,
    distanceDiff: 359,
    roadCosts: 12583,
    roadCostsDiff: 98,
    fuel: 24998,
    fuelDiff: 2100,
    drivingTime: 2317,
    loadedPercent: 89,
    emptyPercent: 11,
  },
  {
    id: "6",
    name: "Marian Kowalski",
    driversCount: 9,
    ordersCount: 126,
    revenue: 98280,
    distance: 87948,
    distanceDiff: 1211,
    roadCosts: 14423,
    roadCostsDiff: 321,
    fuel: 22866,
    fuelDiff: -400,
    drivingTime: 2281,
    loadedPercent: 87,
    emptyPercent: 13,
  },
  {
    id: "7",
    name: "Ada Kot",
    driversCount: 9,
    ordersCount: 99,
    revenue: 87120,
    distance: 71379,
    distanceDiff: 987,
    roadCosts: 11278,
    roadCostsDiff: 277,
    fuel: 19986,
    fuelDiff: 710,
    drivingTime: 1792,
    loadedPercent: 96,
    emptyPercent: 4,
  },
  {
    id: "8",
    name: "Roman Tarski",
    driversCount: 8,
    ordersCount: 136,
    revenue: 106080,
    distance: 95336,
    distanceDiff: 1342,
    roadCosts: 13347,
    roadCostsDiff: 325,
    fuel: 26694,
    fuelDiff: 950,
    drivingTime: 2462,
    loadedPercent: 85,
    emptyPercent: 15,
  },
]

const mockFleetTrucks: FleetTruck[] = [
  {
    id: "1",
    truckNumber: "LB 43534",
    driverName: "Dmitry Petrov",
    ordersCount: 13,
    revenue: 10647,
    distance: 10179,
    distanceDiff: 200,
    roadCosts: 1425,
    roadCostsDiff: 200,
    fuel: 27,
    fuelDiff: 0,
    drivingTime: 221,
    drivingTimeDiff: 15,
    loadedKm: 9161,
    emptyKm: 1018,
    loadedPercent: 90,
    emptyPercent: 10,
  },
  {
    id: "2",
    truckNumber: "LBL 42435",
    driverName: "Feliks Solovev",
    ordersCount: 15,
    revenue: 12750,
    distance: 10800,
    distanceDiff: 512,
    roadCosts: 1620,
    roadCostsDiff: 120,
    fuel: 26,
    fuelDiff: 0,
    drivingTime: 240,
    drivingTimeDiff: 5,
    loadedKm: 9828,
    emptyKm: 972,
    loadedPercent: 91,
    emptyPercent: 9,
  },
  {
    id: "3",
    truckNumber: "LBL 43523",
    driverName: "Yemelyan Kuzn",
    ordersCount: 16,
    revenue: 11040,
    distance: 12800,
    distanceDiff: 350,
    roadCosts: 2048,
    roadCostsDiff: 198,
    fuel: 29,
    fuelDiff: 0,
    drivingTime: 240,
    drivingTimeDiff: 9,
    loadedKm: 12160,
    emptyKm: 640,
    loadedPercent: 95,
    emptyPercent: 5,
  },
  {
    id: "4",
    truckNumber: "LB 23432",
    driverName: "Piotr Nowak",
    ordersCount: 12,
    revenue: 9576,
    distance: 8196,
    distanceDiff: 99,
    roadCosts: 1221,
    roadCostsDiff: 24,
    fuel: 26,
    fuelDiff: 0,
    drivingTime: 216,
    drivingTimeDiff: 12,
    loadedKm: 7212,
    emptyKm: 984,
    loadedPercent: 88,
    emptyPercent: 12,
  },
  {
    id: "5",
    truckNumber: "LBL 53422",
    driverName: "Valerian Umski",
    ordersCount: 11,
    revenue: 11209,
    distance: 9713,
    distanceDiff: 23,
    roadCosts: 1457,
    roadCostsDiff: 220,
    fuel: 29,
    fuelDiff: 0,
    drivingTime: 187,
    drivingTimeDiff: 5,
    loadedKm: 8645,
    emptyKm: 1068,
    loadedPercent: 89,
    emptyPercent: 11,
  },
  {
    id: "6",
    truckNumber: "LB 34521",
    driverName: "Yasha Romanow",
    ordersCount: 17,
    revenue: 13413,
    distance: 11611,
    distanceDiff: 451,
    roadCosts: 1974,
    roadCostsDiff: 87,
    fuel: 31,
    fuelDiff: 0,
    drivingTime: 255,
    drivingTimeDiff: 21,
    loadedKm: 10100,
    emptyKm: 1511,
    loadedPercent: 87,
    emptyPercent: 13,
  },
]

const mockOrderDocuments: OrderDocument[] = [
  {
    id: "1",
    documentName: "Sprint Logistyka.pdf",
    driverName: "Valery Umsky",
    orderDate: "20.01.2026",
    revenue: 365,
    distance: 820,
    distanceDiff: -15,
    roadCosts: 123,
    roadCostsDiff: -2,
    fuelPer100km: 29,
    fuelDiff: -1,
    drivingTime: 14,
    drivingTimeDiff: -0.33,
    loadedPercent: 90,
    emptyPercent: 10,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 835000,
      actualDistance: 820000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
  {
    id: "2",
    documentName: "Hespon spolka",
    driverName: "Szymon Pietrov",
    orderDate: "19.01.2026",
    revenue: 440,
    distance: 675,
    distanceDiff: 5,
    roadCosts: 101,
    roadCostsDiff: 5,
    fuelPer100km: 27,
    fuelDiff: 1,
    drivingTime: 16,
    drivingTimeDiff: 0.17,
    loadedPercent: 90,
    emptyPercent: 10,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 670000,
      actualDistance: 675000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
  {
    id: "3",
    documentName: "Wildenhofer Spediti...",
    driverName: "Feliks Solovev",
    orderDate: "18.01.2026",
    revenue: 535,
    distance: 740,
    distanceDiff: 30,
    roadCosts: 111,
    roadCostsDiff: 10,
    fuelPer100km: 28,
    fuelDiff: -1,
    drivingTime: 15,
    drivingTimeDiff: 0.5,
    loadedPercent: 88,
    emptyPercent: 12,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 710000,
      actualDistance: 740000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
  {
    id: "4",
    documentName: "Hespon spolka",
    driverName: "Valery Umsky",
    orderDate: "15.01.2026",
    revenue: 640,
    distance: 510,
    distanceDiff: -20,
    roadCosts: 77,
    roadCostsDiff: -2,
    fuelPer100km: 30,
    fuelDiff: -1,
    drivingTime: 18,
    drivingTimeDiff: -0.58,
    loadedPercent: 86,
    emptyPercent: 14,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 530000,
      actualDistance: 510000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
  {
    id: "5",
    documentName: "Harper Logistics",
    driverName: "Szymon Pietrov",
    orderDate: "13.01.2026",
    revenue: 515,
    distance: 630,
    distanceDiff: -10,
    roadCosts: 95,
    roadCostsDiff: 5,
    fuelPer100km: 26,
    fuelDiff: 1,
    drivingTime: 17,
    drivingTimeDiff: -0.08,
    loadedPercent: 86,
    emptyPercent: 14,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 640000,
      actualDistance: 630000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
  {
    id: "6",
    documentName: "Kuehne nagel",
    driverName: "Feliks Solovev",
    orderDate: "08.01.2026",
    revenue: 735,
    distance: 584,
    distanceDiff: 24,
    roadCosts: 88,
    roadCostsDiff: -2,
    fuelPer100km: 25,
    fuelDiff: -2,
    drivingTime: 19,
    drivingTimeDiff: 0.5,
    loadedPercent: 86,
    emptyPercent: 14,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 560000,
      actualDistance: 584000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
  {
    id: "7",
    documentName: "Hespon spolka",
    driverName: "Feliks Solovev",
    orderDate: "07.01.2026",
    revenue: 350,
    distance: 600,
    distanceDiff: 2,
    roadCosts: 90,
    roadCostsDiff: 5,
    fuelPer100km: 29,
    fuelDiff: 2,
    drivingTime: 15,
    drivingTimeDiff: 0.17,
    loadedPercent: 86,
    emptyPercent: 14,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 598000,
      actualDistance: 600000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
  {
    id: "8",
    documentName: "Harper Logistics",
    driverName: "Valery Umsky",
    orderDate: "13.01.2026",
    revenue: 515,
    distance: 630,
    distanceDiff: -10,
    roadCosts: 95,
    roadCostsDiff: -4,
    fuelPer100km: 27,
    fuelDiff: 1,
    drivingTime: 17,
    drivingTimeDiff: -0.08,
    loadedPercent: 88,
    emptyPercent: 12,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 640000,
      actualDistance: 630000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
  {
    id: "9",
    documentName: "Kuehne nagel",
    driverName: "Feliks Solovev",
    orderDate: "08.01.2026",
    revenue: 735,
    distance: 584,
    distanceDiff: 24,
    roadCosts: 88,
    roadCostsDiff: 5,
    fuelPer100km: 26,
    fuelDiff: -2,
    drivingTime: 19,
    drivingTimeDiff: 0.5,
    loadedPercent: 86,
    emptyPercent: 14,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 560000,
      actualDistance: 584000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
  {
    id: "10",
    documentName: "Hespon spolka",
    driverName: "Valery Umsky",
    orderDate: "07.01.2026",
    revenue: 350,
    distance: 600,
    distanceDiff: 2,
    roadCosts: 90,
    roadCostsDiff: -6,
    fuelPer100km: 28,
    fuelDiff: 1,
    drivingTime: 15,
    drivingTimeDiff: 0.17,
    loadedPercent: 86,
    emptyPercent: 14,
    routeData: {
      driverJid: "valerian.umsky@demo",
      expectedDistance: 598000,
      actualDistance: 600000,
      firstStopId: "1761654645251840",
      lastStopId: "1761654255509025",
      routeTimestamp: "2025-10-27T09:10:12.125086+00:00",
      startTimestamp: "2025-10-27T13:48:36.375328+00:00",
      endTimestamp: "2025-10-28T09:16:36.762154+00:00",
    },
  },
]

export function getMockStatsData(_filters: StatsFilters): StatsData {
  return {
    // Summary tab - matching Figma design with blue annotation values
    ordersSummary: {
      ordersCount: 1208,
      kmPerOrder: 683,
      revenue: 990384,
      revenuePerKm: 1.2,
      distance: 825320,
      costPerOrder: 819,
      roadCosts: 123798,
      roadCostsPerKm: 15,
      fuel: 222836,
      fuelPerKm: 27,
      drivingTime: 20536,
      hoursPerOrder: 17,
    },
    distanceComparison: {
      planned: 801001,
      actual: 825320,
      difference: 24319,
      differencePercent: 3.1,
    },
    roadCostsComparison: {
      planned: 117200,
      actual: 123798,
      difference: 6598,
      differencePercent: 5.6,
    },
    fuelComparison: {
      planned: 218000,
      actual: 222836,
      difference: 4836,
      differencePercent: 2.2,
    },
    loadedKmComparison: {
      totalDistance: 825320,
      loadedKm: 755993,
      loadedPercent: 91.6,
      emptyKm: 69326,
      emptyPercent: 8.4,
    },

    // Biuro tab
    dispatchers: mockDispatchers,

    // Flota tab
    fleetTrucks: mockFleetTrucks,

    // Zlecenia tab
    orderDocuments: mockOrderDocuments,
  }
}
